module.exports = __webpack_public_path__ + "static/media/icon-check.ae6fab7c.svg";